import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-71d15e9c")

_pushScopeId("data-v-71d15e9c")
const _hoisted_1 = {
  class: "writing-board",
  ref: "writingBoardRef"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconWrite = _resolveComponent("IconWrite")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("canvas", {
      class: "canvas",
      ref: "canvasRef",
      onMousedown: _cache[1] || (_cache[1] = $event => _ctx.handleMousedown($event)),
      onMousemove: _cache[2] || (_cache[2] = $event => _ctx.handleMousemove($event)),
      onMouseup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleMouseup())),
      onTouchstart: _cache[4] || (_cache[4] = $event => _ctx.handleMousedown($event)),
      onTouchmove: _cache[5] || (_cache[5] = $event => _ctx.handleMousemove($event)),
      onTouchend: _cache[6] || (_cache[6] = ($event: any) => {_ctx.handleMouseup(); _ctx.mouseInCanvas = false}),
      onMouseleave: _cache[7] || (_cache[7] = ($event: any) => {_ctx.handleMouseup(); _ctx.mouseInCanvas = false}),
      onMouseenter: _cache[8] || (_cache[8] = ($event: any) => (_ctx.mouseInCanvas = true))
    }, null, 544),
    (_ctx.mouseInCanvas && _ctx.model === 'pen')
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "pen",
          style: {
        left: _ctx.mouse.x - _ctx.penSize / 2 + 'px',
        top: _ctx.mouse.y - 36 + _ctx.penSize / 2 + 'px',
        color: _ctx.color,
      }
        }, [
          _createVNode(_component_IconWrite, {
            class: "icon",
            size: "36"
          })
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.mouseInCanvas && _ctx.model === 'eraser')
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "eraser",
          style: {
        left: _ctx.mouse.x - _ctx.rubberSize / 2 + 'px',
        top: _ctx.mouse.y - _ctx.rubberSize / 2 + 'px',
        width: _ctx.rubberSize + 'px',
        height: _ctx.rubberSize + 'px',
      }
        }, null, 4))
      : _createCommentVNode("", true)
  ], 512))
})